import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { signInPageModule } from './modules/auth';

export default createApp({
  features: [catalogPlugin, navModule, signInPageModule],
});
